import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WelcomePlannerViewService } from '../../services';
import { HeaderComponent } from './components/header/header.component';
import { WelcomePlannerItemsComponent, WelcomePlannerButtonComponent } from "./components";


@Component({
  selector: 'app-welcome-planner-content',
  standalone: true,
  imports: [
    TranslateModule,
    HeaderComponent,
    WelcomePlannerItemsComponent,
    WelcomePlannerButtonComponent
],
  templateUrl: './welcome-planner-content.component.html',
  styleUrls: ['./welcome-planner-content.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomePlannerContentComponent {
  private _welcomePlannerViewService = inject(WelcomePlannerViewService);

  protected isAllReadyViewShown = this._welcomePlannerViewService.isAllReadyViewShown;
}
